<div class="table-container">
    <div class="create-involved-form sticky-header">
        <involved-details
            [currentTicket]="currentTicket"
            (formClosed)="onFormClosed()">
        </involved-details>
    </div>

    <table class="table">
        <tbody>
        <ng-container *ngFor="let involved of involveds | async">
            <tr>
                <td class="user-cell">
                    <div class="involved-item">
                        <span class="user-info">
                            {{ userLabel(involved) }}
                        </span>
                        <button class="btn-delete" (click)="removeInvolved(involved)">
                            <span class="material-icons-outlined">delete</span>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-container>
        </tbody>
    </table>
</div>